import React, { Fragment, Suspense } from 'react';

import YatLoader from '@pkg/components/Sections/Profile/Loader';

import { useRoutesConfig } from '@app/routes/useRoutesConfig';

export const YatRoutes = () => {
    const routesConfig = useRoutesConfig();

    return (
        <Fragment>
            <Suspense fallback={<YatLoader />}>{routesConfig}</Suspense>
        </Fragment>
    );
};
